import React, { FC } from "react";
import { Chip, ChipPropsColorOverrides } from "@mui/material";
import ApprovalRoundedIcon from "@mui/icons-material/ApprovalRounded";
import { OverridableStringUnion } from "@mui/types";
interface RubberStampProps {
  text: string;
  color?: OverridableStringUnion<
    "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning",
    ChipPropsColorOverrides
  >;
  size?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  isdisabled?: boolean;
}

const RubberStamp: FC<RubberStampProps> = ({ text, color, onClick, isdisabled = false }) => {
  return (
    <Chip
      label={text}
      icon={<ApprovalRoundedIcon />}
      onClick={onClick}
      color={color}
      sx={{ backgroundColor: (color ?? "") + ".main" }}
      variant="filled"
    />
  );
};

export default RubberStamp;
